import { Select } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'

import {
  DirtyFieldLabel,
  TooltipInfoProps,
} from './dirty-field'

import { isFieldDirty } from './form-dirty-utils'
import React from 'react'

interface DirtySelectProps<
  T extends Record<string, any>,
> extends Omit<
  React.ComponentProps<typeof Select>,
  'form' | 'label'
>, TooltipInfoProps {
  form: UseFormReturnType<T>
  field: keyof T
  label: string
}

export function DirtySelect<T extends Record<string, any>>({
                                                             form,
                                                             field,
                                                             label,
                                                              tooltip,
                                                             ...props
                                                           }: DirtySelectProps<T>) {
  return (
    <Select
      label={
        <DirtyFieldLabel
          label={label}
          tooltip={tooltip}
          changed={isFieldDirty(
            form,
            field,
          )}
        />
      }
      {...form.getInputProps(
        field as string,
      )}
      {...props}
    />
  )
}